export default __webpack_public_path__ + "static/assets/8db370466b33669c7b903c13544bd225.svg";